import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessengerMessageInlineChannelSuggestions = _resolveComponent("MessengerMessageInlineChannelSuggestions")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resolveMessageComponent), { message: _ctx.message }, _createSlots({ _: 2 }, [
    (
        _ctx.message.data.eventType == 'no_agents_online_notification' &&
        _ctx.messageIsFromCurrentConversation &&
        !_ctx.conversationIsTransferred &&
        !_ctx.conversationIsEnded
      )
      ? {
          name: "bottom",
          fn: _withCtx(() => [
            _createVNode(_component_MessengerMessageInlineChannelSuggestions)
          ])
        }
      : undefined
  ]), 1032, ["message"]))
}